import type { ConstValues } from './helpers';

export type PostForecastDataResponse = {
  job_id: string;
  not_included_fields: string[];
};

export type AudienceMonthlyRequestsResponse = {
  total: number | null;
};

export const DealForecastStatus = {
  InProgress: 'in progress',
  Ready: 'ready',
  Error: 'error',
} as const;
export type DealForecastStatus = ConstValues<typeof DealForecastStatus>;

export type DealForecast = {
  ad_sizes: AdSizeForecasting[];
  bid_guidance_high: number;
  bid_guidance_low: number;
  requests_with_targeting: number;
  requests_without_targeting: number;
  top_domains: TopDomainsForecasting[];
  top_bundles: TopBundlesForecasting[];
  us_cities: USCityForecasting[];
  video_durations: VideoDurationForecasting[];
};

export type DealForecastApi = {
  ad_sizes: AdSizeForecasting[] | null;
  bid_guidance_high: number | null;
  bid_guidance_low: number | null;
  requests_with_targeting: number | null;
  requests_without_targeting: number | null;
  top_bundles: TopBundlesForecasting[] | null;
  top_domains: TopDomainsForecasting[] | null;
  us_cities: USCityForecasting[] | null;
  video_durations: VideoDurationForecasting[] | null;
};

export type DealForecastApiResponse = {
  status: DealForecastStatus;
  output?: DealForecastApi;
  msg?: string;
};

export type AdSizeForecasting = {
  ad_size: string;
  fraction: number;
};

export type TopDomainsForecasting = {
  domain: string;
  fraction: number;
};

export type TopBundlesForecasting = {
  bundle: string;
  fraction: number;
};

export type TopMarketRequestsEntries = TopBundlesForecasting[] | TopDomainsForecasting[];

export type USCityForecasting = {
  city: string;
  fraction: number;
  state: string;
};

export type VideoDurationForecasting = {
  fraction: number;
  maxduration: number;
  minduration: number;
};

export type SortingKeysForecasting = keyof AdSizeForecasting | keyof USCityForecasting | keyof VideoDurationForecasting;
export type DataTypeForecasting = AdSizeForecasting | USCityForecasting | VideoDurationForecasting;

export const DealForecastStateMode = {
  Loading: 'loading',
  Error: 'error',
  All_Set: 'all-set',
  No_Data: 'no-data',
} as const;
export type DealForecastStateMode = ConstValues<typeof DealForecastStateMode>;
